import React from "react";
import { useSelector } from "react-redux";
import i18n from "../../../i18n/config";
import ActionLink from "../../Common/ActionLink";

// types
import { RootState } from "../../../types/redux";
import ReactCountryFlag from "react-country-flag";

interface RecipientGetsRowProps {
  amount: number | null;
  onLimits: () => void;
}

const RecipientGetsRow = ({
  amount,
  onLimits,
}: RecipientGetsRowProps): React.ReactElement => {
  const selectedCurrency = useSelector(
    (state: RootState) => state.sendMoney.selectedCurrency
  );
  const selectedCountry = useSelector(
    (state: RootState) => state.sendMoney.selectedCountry
  );

  const walletLimitsApply = useSelector(
    (state: RootState) => state.sendMoney.walletLimitsApply
  );

  return (
    <div>
      <div className="flex-row justify-content-between align-items-center mb-8">
        <label className="text-primary">
          {i18n.t("PAGES.SEND_MONEY.TRANSFER_DETAILS.RECIPIENT_LABEL")}
        </label>
        {walletLimitsApply && (
          <ActionLink
            classes="text-blue-700 no-underline bold font-size-sm"
            clickFunc={onLimits}
          >
            {i18n.t("PAGES.SEND_MONEY.TRANSFER_DETAILS.LIMITS_APPLY")}
          </ActionLink>
        )}
      </div>
      <div className="flex-row justify-content-between align-items-center">
        <span className="bold text-primary font-size-xxl">
          {amount != null ? amount.toFixed(2) : "0.00"}
        </span>
        <div className="flex-row align-items-center">
          <ReactCountryFlag
            countryCode={selectedCountry}
            className="emojiFlag flag"
            style={{
              fontSize: "24px",
              lineHeight: "24px",
            }}
            aria-hidden
          />
          <span className="text-primary ml-8">{selectedCurrency}</span>
        </div>

      </div>
    </div>
  );
};

export default RecipientGetsRow;